module.exports = __webpack_public_path__ + "static/media/announcement.bb29c147.svg";